import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonRadioButton } from './RadioButton.definition';
import { chameleonSvg } from '../Svg';
import { chameleonTypography } from '../Typography/Typography.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }), chameleonRadioButton({ prefix }), chameleonSvg({ prefix }));
}
